function convertSquareInchToAcre(num) {
  let eq =
    "Converting " +
    num +
    " square inch to acre: \n" +
    num +
    " * 1.594225079e-7 = ";
  let rep = num * 1.594225079e-7 ;
  return eq + rep.toFixed(7);
}

function convertSquareInchToHectare(num) {
  let eq =
    "Converting " +
    num +
    " square inch to hectare: \n" +
    num +
    " * 6.4516e-8 = ";
  let rep = num * 6.4516e-8 ;
  return eq + rep.toFixed(8);
}

function convertSquareInchToSquareFoot(num) {
  let eq =
    "Converting " +
    num +
    " square inch to square foot: \n" +
    num +
    " * 0.006944444444 = ";
  let rep = num * 0.006944444444 ;
  return eq + rep.toFixed(5);
}

function convertSquareInchToSquareMeter(num) {
  let eq =
    "Converting " +
    num +
    " square inch to square meter: \n" +
    num +
    " * 0.00064516 = ";
  let rep = num * 0.00064516;
  return eq + rep.toFixed(5);
}

function convertSquareInchToSquareMile(num) {
  let eq =
    "Converting " +
    num +
    " square inch to square mile: \n" +
    num +
    " * 2.490976686e-10 = ";
  let rep = num * 2.490976686e-10 ;
  return eq + rep.toFixed(10);
}

function convertSquareInchToSquareYard(num) {
  let eq =
    "Converting " +
    num +
    " square inch to square yard: \n" +
    num +
    " * 0.0007716049383 = ";
  let rep = num * 0.0007716049383;
  return eq + rep.toFixed(6);
}

export {
  convertSquareInchToAcre,
  convertSquareInchToHectare,
  convertSquareInchToSquareFoot,
  convertSquareInchToSquareMeter,
  convertSquareInchToSquareMile,
  convertSquareInchToSquareYard
};
